import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

const useBusinessProfileFilters = ({ defaultQuery, searchOnChange = false }) => {
  const [selectedFilter, setSelectedFilter] = useState('name');
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let query = buildQuery();
    setCurrentQuery(query);
  }, [selectedFilter, pagination]);

  const buildQuery = () => {
    const query = { ...defaultQuery, ...pagination };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }

    return query;
  };

  useEffect(() => {
    if (!searchOnChange) return;

    const handler = debounce(() => {
      setCurrentQuery(buildQuery());
    }, 500);

    handler();
    return () => handler.cancel();
  }, [searchTerm]);

  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handlePaginationChange = (page, limit) => setPagination({ page: page, size: limit });

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    searchTerm,
    selectedFilter,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  };
};

export default useBusinessProfileFilters;
